<script setup lang="ts">
import type { Image } from '@sanity/types';
import BaseImage from '@pkg/ui/components/base/BaseImage.vue';

defineProps<{
  image?: Image;
}>();
</script>

<template>
  <BaseImage v-if="image" :image="image" class="c-image" />
</template>

<style scoped>
.c-image {
  width: 100%;
  height: 360px;
  object-fit: cover;

  @screen tablet-wide {
    height: 640px;
  }
}
</style>
